/* Bag & Bloom - motion engine */
(function () {
  if (window.__bbCore) return;
  window.__bbCore = true;

  var SEL = '.bb-r, .bb-stagger, [data-bb-r]';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  function showAll(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el) { el.classList.add('is-in'); });
  }

  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.10 });
  }

  function observe(root) {
    var scope = root || document;
    if (!io) { showAll(scope); return; }
    scope.querySelectorAll(SEL).forEach(function (el) {
      if (el.dataset.bbSeen) return;
      el.dataset.bbSeen = '1';
      io.observe(el);
    });
  }

  /* ---------- count up stats ---------- */
  function countUp(el) {
    var raw = (el.textContent || '').trim();
    if (!/^\d+$/.test(raw)) return;              // skip things like "1-3"
    if (reduce) return;
    var target = parseInt(raw, 10);
    if (target > 9999) return;
    var dur = 1100, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = '0';
    requestAnimationFrame(step);
  }

  function initCounters() {
    var nums = document.querySelectorAll('[data-bb-count]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) return;
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        countUp(e.target);
        cio.unobserve(e.target);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { cio.observe(n); });
  }

  /* ---------- scroll progress ---------- */
  function initProgress() {
    var bar = document.querySelector('.bb-prog');
    if (!bar) return;
    var ticking = false;
    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? window.scrollY / h : 0;
      bar.style.setProperty('--p', Math.min(Math.max(p, 0), 1));
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  /* ---------- sticky mobile bar ---------- */
  function initSticky() {
    var bar = document.querySelector('.bb-sticky');
    if (!bar) return;
    var ticking = false;
    function update() {
      if (window.scrollY > window.innerHeight * 0.6) bar.classList.add('is-on');
      else bar.classList.remove('is-on');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  function init() {
    observe(document);
    initCounters();
    initProgress();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    showAll(e.target);
    observe(e.target);
    initSticky();
  });
})();
